import OptOutsPage from "/src/features/supervision/optOuts/components/OptOutsPage";

function OptOutList() {
    return <OptOutsPage />;
}

export default OptOutList;
